import { CURRENCY_SYMBOL } from "../constants/currency";

/** Backend returns negative for amount owed; display as a positive IQD figure. */
export const formatOutstandingDisplay = (
  value: number | undefined | null,
  currency?: string
): string => {
  const prefix = currency?.trim() ? `${currency.trim()} ` : CURRENCY_SYMBOL;
  const amount = Math.abs(Number(value ?? 0));
  return `${prefix}${amount.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
};

export const formatWalletDisplay = (
  value: number | undefined | null,
  currency?: string
): string => {
  const prefix = currency?.trim() ? `${currency.trim()} ` : CURRENCY_SYMBOL;
  const amount = Math.max(0, Number(value ?? 0));
  return `${prefix}${amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const pickField = (
  raw: Record<string, unknown> | null | undefined,
  ...keys: string[]
) => {
  for (const key of keys) {
    const val = raw?.[key];
    if (val !== undefined && val !== null) return val;
  }
  return undefined;
};

/** Metrics only — do not use Sage totalOutstanding for app balance cards. */
export const normalizeDashboardResponse = (
  raw: Record<string, unknown> | null | undefined
) => ({
  recentOrders: Number(pickField(raw, "recentOrders", "RecentOrders") ?? 0),
  invoicesDue: Number(pickField(raw, "invoicesDue", "InvoicesDue") ?? 0),
});

/** Source of truth for wallet + internal outstanding (GET /customers/balance-summary). */
export const normalizeBalanceSummaryResponse = (
  raw: Record<string, unknown> | null | undefined
) => ({
  appTotalOutstandingBalance: Number(
    pickField(
      raw,
      "totalOutstandingBalance",
      "TotalOutstandingBalance",
      "appTotalOutstandingBalance",
      "AppTotalOutstandingBalance"
    ) ?? 0
  ),
  appWalletBalance: Number(
    pickField(raw, "walletBalance", "WalletBalance", "appWalletBalance", "AppWalletBalance") ??
      0
  ),
  currency: String(pickField(raw, "currency", "Currency") ?? "IQD"),
});
